/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit BoardItem/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Popover from 'DesignSystem/Popover/index'
import PopoverContentHover from 'DesignSystem/Popover/PopoverContentHover/index'
import PopoverTrigger from 'DesignSystem/Popover/PopoverTrigger/index'
import React from 'react'
import TaskBoardIcon from 'DesignSystem/TaskBoardIcon/index'
import Tooltip from 'DesignSystem/Tooltip/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function BoardItem({
  children,
  viewPath = "/App/Account/Content/Tasks/New/Menu/Collapsed/BoardsList/Content/BoardItem"
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
  let flow = fromFlow.useFlow()
let boardIdValueData = fromData.useDataValue({ viewPath,
context: 'board',
path: 'id',
})
let tabSelectedBoardIdValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.board_id',
})
let aggregateData = fromAggregate.equals(boardIdValueData, tabSelectedBoardIdValueData)
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  isHovered
  
})
let boardMetadataBoardIconIdValueData = fromData.useDataValue({ viewPath,
context: 'board',
path: 'metadata.board_icon_id',
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let boardNameValueData = fromData.useDataValue({ viewPath,
context: 'board',
path: 'name',
})
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
  return (<React.Fragment
>
<Popover
  viewPath={`${viewPath}/Popover`}
 showOnClick={false}
 showOnHover={true}
 placement="right"
 offsetMainAxis={8}
 offsetCrossAxis={-24}
 width="100%"
>
{childProps => (
<React.Fragment>
<PopoverTrigger
{...childProps}
  viewPath={`${viewPath}/PopoverTrigger`}
>
{childProps => (
<button
  data-testid="BoardItem.Horizontal"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 style={{'--mb-1-sGRRd': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--o-2-sGRRd': childProps.isHovered ? "70%" : flow.has(fromFlow.normalizePath(viewPath, '../../../../../Content/Home')) ? "40%" : aggregateData ? "100%" : "40%"}}
 className={`views-block ${styles.Horizontal}`}
>
<TaskBoardIcon
  viewPath={`${viewPath}/TaskBoardIcon`}
 borderTopRightRadius={dtSpaceXxs}
 borderTopLeftRadius={dtSpaceXxs}
 borderBottomRightRadius={dtSpaceXxs}
 borderBottomLeftRadius={dtSpaceXxs}
 width={34}
 height={34}
 iconHeight={16}
 iconWidth={16}
 data="board.metadata.board_icon_id"
 iconId={boardMetadataBoardIconIdValueData}
/>
</button>
)}
</PopoverTrigger>
<PopoverContentHover
{...childProps}
  viewPath={`${viewPath}/PopoverContentHover`}
>
{childProps => (
<Tooltip
{...childProps}
  viewPath={`${viewPath}/Tooltip`}
 backgroundColor={dtColorsWhite}
 color={dtColorsNeutral500}
 height="auto"
 className="new-shadow"
 whiteSpace="normal"
 data="board.name"
 text={boardNameValueData}
 className="new-shadow"
/>
)}
</PopoverContentHover>
</React.Fragment>
)}
</Popover>
{children}
</React.Fragment>)
}